import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LanguageLowercase } from 'store/app/types'
import { DEBUG_I18N, IS_PROD_OR_BETA } from 'constants/envs'
import dutch from './dutch'
import french from './french'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'
import 'dayjs/locale/fr'
import { getInitialLanguage } from 'utils/language.ts'

export const defaultNS = 'common'
export const nameSpaces = Object.keys(dutch)

export const resources = {
  nl: dutch,
  fr: french
} as const

void i18n.use(initReactI18next).init({
  returnNull: false,
  debug: !IS_PROD_OR_BETA && DEBUG_I18N,
  lng: getInitialLanguage(),
  fallbackLng: LanguageLowercase.NL,
  ns: nameSpaces,
  defaultNS,
  resources
})

dayjs.locale(i18n.language)
i18n.on('languageChanged', (lng) => dayjs.locale(lng))

export default i18n
